
import React from "react";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { clientFormSchema } from "@/contexts/ProgramCreationContext";
import { Client } from "@/components/programs/ClientSelection";
import { Form } from "@/components/ui/form";
import { PersonalInfoFields } from "./PersonalInfoFields";
import { GoalsNotesFields } from "./GoalsNotesFields";

type ClientDetailsFormProps = {
  client: Client;
  onSubmit: (data: z.infer<typeof clientFormSchema>) => void;
};

export const ClientDetailsForm = ({ client, onSubmit }: ClientDetailsFormProps) => {
  const clientForm = useForm<z.infer<typeof clientFormSchema>>({
    resolver: zodResolver(clientFormSchema),
    defaultValues: {
      name: client.name,
      email: client.email || "",
      phone: client.phone || "",
      age: client.age,
      gender: (client.gender as "male" | "female" | "other") || "male",
      goals: client.goals || "",
      notes: client.notes || ""
    },
  });

  return (
    <Form {...clientForm}>
      <form className="space-y-4" onSubmit={clientForm.handleSubmit(onSubmit)}>
        <PersonalInfoFields control={clientForm.control} />
        <GoalsNotesFields control={clientForm.control} />
      </form>
    </Form>
  );
};
